import {format} from 'date-fns'

// TODO: Test
export function formatDate(date: string): string {
  return format(Date.parse(date), 'dd/MM/yyyy')
}
